import { render, staticRenderFns } from "./footer-nav.vue?vue&type=template&id=041f6508&scoped=true"
import script from "./footer-nav.vue?vue&type=script&lang=js"
export * from "./footer-nav.vue?vue&type=script&lang=js"
import style0 from "./footer-nav.vue?vue&type=style&index=0&id=041f6508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041f6508",
  null
  
)

export default component.exports